export default "__VITE_ASSET__CRD3dBiK__"